// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2505B","errorLogs":"EditorFooter_errorLogs__3tlRv"};